import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import toast styles
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/global.css";
import "../css/index.css";
import "../css/font-awesome.min.css";

const HomeProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false); // Prevent multiple clicks
  const userId = localStorage.getItem("userId"); // Get user ID from localStorage

  // 📌 Fetch Products from API (including stock)
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("https://api.irfanelectricals.com/api/products");
        console.log("Fetched Products:", response.data);
        setProducts(response.data.products.slice(0, 20)); // Take only the first 4 products
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  const handleAddToCart = async (productId, stock) => {
    console.log("User ID being used:", userId);

    if (!userId) {
      toast.error("❌ Please log in to add products to the cart.");
      return;
    }

    if (stock === 0) {
      toast.warning("⚠️ This product is out of stock.");
      return;
    }

    setLoading(true); // Disable the button to prevent multiple clicks

    try {
      const response = await axios.post(`https://api.irfanelectricals.com/api/cart/${userId}/item`, {
        user_id: userId,
        product_id: productId,
        quantity: 1,
      });

      console.log("Cart Response:", response.data);

      if (response.status === 200 || response.status === 201) {
        toast.success("✅ Product added to cart!");
      } else {
        toast.error(`❌ Failed: ${response.data.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error adding product:", error.response || error);

      if (error.response) {
        toast.error(`❌ API Error: ${error.response.data.message || error.message}`);
      } else {
        toast.error("⚠️ Network error! Check server.");
      }
    } finally {
      setLoading(false); // Re-enable the button
    }
  };

  return (
    <section id="list" className="p-3 bg-light">
      <div className="container-xl">
        <ToastContainer position="top-right" autoClose={2000} /> {/* Toast notification container */}
        <div className="row text-center mb-4">
          <div className="col-md-12">
            <h4 className="col_blue">Our Product</h4>
            <h1 className="mt-3 mb-0">Best Seller Product</h1>
          </div>
        </div>
        <div className="row">
          {products.length > 0 ? (
            products.map((product) => (
              <div key={product.id} className="col-md-3 mb-4">
                <div className="card h-100 shadow text-center d-flex flex-column">

                  {/* Product Image */}
                  <Link to={`/product/${product.id}`} className="d-block">
                    <img
                      src={`https://api.irfanelectricals.com/uploads/${product.images[0]}`}
                      alt={product.name}
                      className="card-img-top img-fluid"
                      style={{ height: "200px", objectFit: "cover" }} // Uniform image size
                      onError={(e) => (e.target.src = "https://via.placeholder.com/270")}
                    />
                  </Link>

                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title">{product.name}</h5>
                    <p className="card-text">
                      <span className="text-decoration-line-through text-muted">${product.originalPrice?.toFixed(2)}</span>{' '}
                      <strong>${product.price?.toFixed(2)}</strong>
                    </p>

                    {/* Lot (Stock) Display */}
                    <p className="text-info">
                      <strong>Lot item:</strong> {product.stock !== undefined ? product.stock : "Loading..."}
                    </p>

                    {/* Spacer to push buttons to bottom */}
                    <div className="mt-auto">
                      <div className="d-flex justify-content-center gap-2">
                        {/* Add to Cart Button */}
                        <button className="btn btn-success" onClick={() => handleAddToCart(product.id)} disabled={loading}>
                          <i className="fa fa-shopping-cart me-1"></i>
                          {loading ? "Adding..." : "Add To Cart"}
                        </button>

                        {/* eBay Purchase Button */}
                        {product.ebay_link ? (
                          <a href={product.ebay_link} target="_blank" rel="noopener noreferrer" className="btn btn-warning">
                            <i className="fa fa-external-link me-1"></i> Buy from eBay
                          </a>
                        ) : (
                          <button className="btn btn-secondary" disabled>
                            <i className="fa fa-external-link me-1"></i> Not Available
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <p>Loading products...</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default HomeProducts;
